(function () {
  'use strict';

  var BUNDLE_KEY = 'luxlaria-wellness-bundle';
  var DISCOUNT_ATTEMPT_KEY = 'lux-wellness-discount-attempted';

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function discountUrl(code, redirectPath) {
    return (
      cartRoot() +
      'discount/' +
      encodeURIComponent(code) +
      '?redirect=' +
      encodeURIComponent(redirectPath)
    );
  }

  async function fetchCart() {
    var res = await fetch(cartRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error('Could not read cart.');
    return res.json();
  }

  async function applyCartUpdates(updates) {
    if (!updates || !Object.keys(updates).length) return;
    var res = await fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ updates: updates }),
    });
    if (!res.ok) throw new Error('Could not update cart.');
  }

  async function addBundlePair(eyeId, bottleId) {
    var res = await fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: eyeId,
            quantity: 1,
            properties: {
              Bundle: 'Luxlaria Wellness Bundle',
              Includes: 'Smart Eye Therapy System™ + Luxlaria Hydrogen Rich Water Bottle',
              _bundle: BUNDLE_KEY,
            },
          },
          {
            id: bottleId,
            quantity: 1,
            properties: {
              Bundle: 'Luxlaria Wellness Bundle',
              Includes: 'Smart Eye Therapy System™ + Luxlaria Hydrogen Rich Water Bottle',
              _bundle: BUNDLE_KEY,
            },
          },
        ],
      }),
    });
    if (!res.ok) throw new Error('Could not restore bundle.');
  }

  async function repairBundleCart(config) {
    var eyeId = Number(config.getAttribute('data-eye-variant'));
    var bottleId = Number(config.getAttribute('data-bottle-variant'));
    if (!eyeId || !bottleId) return;

    var cart = await fetchCart();
    var updates = {};

    cart.items.forEach(function (item) {
      var isBundle = item.properties && item.properties._bundle === BUNDLE_KEY;
      var isEye = item.variant_id === eyeId;
      var isBottle = item.variant_id === bottleId;

      if (!isBundle || (!isEye && !isBottle)) {
        updates[item.key] = 0;
      }
    });

    if (Object.keys(updates).length) {
      await applyCartUpdates(updates);
    }

    cart = await fetchCart();
    var hasEye = false;
    var hasBottle = false;
    cart.items.forEach(function (item) {
      if (!item.properties || item.properties._bundle !== BUNDLE_KEY) return;
      if (item.variant_id === eyeId) hasEye = true;
      if (item.variant_id === bottleId) hasBottle = true;
    });

    if (!hasEye || !hasBottle) {
      updates = {};
      cart.items.forEach(function (item) {
        updates[item.key] = 0;
      });
      if (Object.keys(updates).length) {
        await applyCartUpdates(updates);
      }
      await addBundlePair(eyeId, bottleId);
    }

    window.location.reload();
  }

  function bundleDiscountApplied(cart, neededSavings) {
    if (!cart || !neededSavings) return false;
    if (Number(cart.total_discount || 0) >= neededSavings) return true;

    var apps = cart.cart_level_discount_applications || [];
    return apps.some(function (app) {
      var title = (app.title || app.discount_application && app.discount_application.title || '').toUpperCase();
      return title.indexOf('WELLNESS') !== -1;
    });
  }

  function showDiscountWarning() {
    /* Checkout routes through the discount URL — no customer-facing warning needed. */
  }

  function updateBundleNote(subtotalBox, discountApplied) {
    var note = subtotalBox && subtotalBox.querySelector('.lux-cart-summary-assurance__value');
    if (!note) return;

    note.textContent = discountApplied
      ? '$1,699.00 — savings applied'
      : '$1,699.00 at checkout';
  }

  function ensureBundleFootnote(subtotalBox, discountApplied) {
    var checkoutBtn = subtotalBox.querySelector('.btn-dark[name="checkout"]');
    subtotalBox.querySelectorAll('.lux-cart-summary-foot, .lux-cart-bundle-note, .lux-cart-discount-warning').forEach(function (el) {
      el.remove();
    });

    var assurance = subtotalBox.querySelector('.lux-cart-summary-assurance');
    if (!assurance) {
      assurance = document.createElement('div');
      assurance.className = 'lux-cart-summary-assurance';
      assurance.innerHTML =
        '<span class="lux-cart-summary-assurance__label">Bundle price</span>' +
        '<span class="lux-cart-summary-assurance__value"></span>';
      if (checkoutBtn) {
        checkoutBtn.insertAdjacentElement('beforebegin', assurance);
      } else {
        subtotalBox.appendChild(assurance);
      }
    }

    updateBundleNote(subtotalBox, discountApplied);
  }

  async function ensureBundleDiscount(config) {
    if (config.getAttribute('data-active') !== 'true') return false;

    var code = (config.getAttribute('data-discount-code') || 'WELLNESS89').trim();
    var neededSavings = Number(config.getAttribute('data-savings') || 8900);
    if (!code || !neededSavings) return false;

    var cart = await fetchCart();
    if (bundleDiscountApplied(cart, neededSavings)) {
      sessionStorage.removeItem(DISCOUNT_ATTEMPT_KEY);
      sessionStorage.removeItem('lux-bundle-discount-pending');
      return true;
    }

    /* Do not auto-redirect to /discount/ on cart load — Cloudflare blocks it.
       Discount is applied when the customer clicks Checkout. */
    return false;
  }

  function bindBundleCheckout(config) {
    if (config.getAttribute('data-active') !== 'true') return;

    var code = (config.getAttribute('data-discount-code') || 'WELLNESS89').trim();
    if (!code) return;

    function goCheckout(event) {
      event.preventDefault();
      event.stopPropagation();
      sessionStorage.removeItem(DISCOUNT_ATTEMPT_KEY);
      var pending = sessionStorage.getItem('lux-bundle-discount-pending') || code;
      window.location.href = discountUrl(pending, '/checkout');
    }

    var checkoutBtn = document.querySelector('gsp-cart-subtotal .btn-dark[name="checkout"]');
    if (checkoutBtn && !checkoutBtn.dataset.luxBundleCheckoutBound) {
      checkoutBtn.dataset.luxBundleCheckoutBound = '1';
      checkoutBtn.addEventListener('click', goCheckout);
    }

    var form = document.getElementById('main-cart-form');
    if (form && !form.dataset.luxBundleCheckoutBound) {
      form.dataset.luxBundleCheckoutBound = '1';
      form.addEventListener('submit', function (event) {
        var submitter = event.submitter;
        if (submitter && submitter.name === 'checkout') {
          goCheckout(event);
        }
      });
    }
  }

  function applyBundlePricing(config, discountApplied) {
    if (config.getAttribute('data-active') !== 'true') return;

    var savings = Number(config.getAttribute('data-savings') || 0);
    var total = Number(config.getAttribute('data-total') || 0);
    var code = (config.getAttribute('data-discount-code') || 'WELLNESS89').trim();
    if (!savings || !total) return;

    var subtotalBox = document.querySelector('gsp-cart-subtotal');
    if (!subtotalBox) return;

    var subtotalRow = subtotalBox.querySelector('.subtotal');
    if (!subtotalRow) return;

    if (!subtotalBox.querySelector('.lux-cart-bundle-savings')) {
      var savingsRow = document.createElement('div');
      savingsRow.className = 'lux-cart-bundle-savings subtotal d-flex justify-content-between';
      savingsRow.innerHTML =
        '<label class="text-heading fw-heading">Wellness Bundle savings</label>' +
        '<p class="mb-0 fw-semibold">-' +
        formatMoney(savings) +
        '</p>';
      subtotalRow.insertAdjacentElement('afterend', savingsRow);
    }

    var totalEl = subtotalBox.querySelector('.totals__total-value');
    if (totalEl) {
      totalEl.textContent = formatMoney(total);
    }

    var subtotalLabel = subtotalRow.querySelector('label');
    if (subtotalLabel) {
      subtotalLabel.textContent = 'Bundle total';
    }

    ensureBundleFootnote(subtotalBox, discountApplied);
  }

  function hideBundleLineProperties() {
    document.querySelectorAll('.template-cart [data-cart-item-property]').forEach(function (el) {
      var nameEl = el.querySelector('[data-cart-item-property-name]');
      if (!nameEl) return;

      var name = nameEl.textContent.replace(':', '').trim();
      if (name === 'Bundle' || name === 'Includes') {
        el.classList.add('lux-cart-item-meta-hidden');
      }
    });
  }

  function enhanceCartLayout() {
    var cartInner = document.querySelector('.template-cart .gsp-main-cart-inner');
    var subtotalBox = document.querySelector('gsp-cart-subtotal');
    if (!cartInner || cartInner.dataset.luxCartEnhanced) return;
    cartInner.dataset.luxCartEnhanced = '1';

    if (subtotalBox && !subtotalBox.querySelector('.lux-cart-summary-head')) {
      var head = document.createElement('div');
      head.className = 'lux-cart-summary-head';
      head.innerHTML =
        '<span class="lux-cart-summary-eyebrow">Order summary</span>' +
        '<h2 class="lux-cart-summary-title">Ready to checkout</h2>';
      subtotalBox.insertBefore(head, subtotalBox.firstChild);
    }

    var checkoutBtn = document.querySelector('gsp-cart-subtotal .btn-dark[name="checkout"]');
    if (checkoutBtn && !checkoutBtn.querySelector('.lux-cart-checkout-arrow')) {
      var label = checkoutBtn.textContent.trim();
      checkoutBtn.innerHTML =
        '<span>' + label + '</span><span class="lux-cart-checkout-arrow" aria-hidden="true">→</span>';
    }

    hideBundleLineProperties();
  }

  async function initCartBundle() {
    var config = document.getElementById('lux-cart-bundle-pricing');
    if (config && config.getAttribute('data-needs-repair') === 'true') {
      try {
        await repairBundleCart(config);
      } catch (e) {
        console.warn('Luxlaria bundle cart repair failed', e);
      }
      return;
    }

    if (!config) {
      enhanceCartLayout();
      return;
    }

    var discountApplied = false;
    if (config.getAttribute('data-active') === 'true') {
      discountApplied = await ensureBundleDiscount(config);
      if (!discountApplied) {
        try {
          var cart = await fetchCart();
          discountApplied = bundleDiscountApplied(
            cart,
            Number(config.getAttribute('data-savings') || 8900)
          );
        } catch (e) {
          console.warn('Luxlaria cart discount check failed', e);
        }
      }

      applyBundlePricing(config, discountApplied);
      bindBundleCheckout(config);
    }

    enhanceCartLayout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartBundle);
  } else {
    initCartBundle();
  }

  document.addEventListener('shopify:section:load', initCartBundle);
})();
